<template>
  <a-drawer
    :maskClosable="false"
    width="60%"
    title="增改功能模块租户"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <a-card :bordered="false">
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="租户名称">
          <span>{{ tenantName || '--' }}</span>
        </a-form-model-item>
        <a-form-model-item label="选择功能模块并配置" prop="selectedModules">
          <div style="margin-bottom: 16px">
            <a-input-search
              v-model="searchKeyword"
              placeholder="搜索模块名称"
              style="width: 300px; margin-bottom: 16px"
              @search="handleSearch"
              allow-clear
            />
          </div>
          <a-table
            :loading="moduleLoading"
            rowKey="id"
            :columns="moduleColumns"
            :data-source="moduleList"
            :pagination="modulePagination"
            :row-selection="rowSelection"
            @change="handleTableChange"
          >
            <span slot="moduleSystemType" slot-scope="text">
              <a-tag :color="getModuleTypeColor(text)">
                {{ getModuleTypeText(text) }}
              </a-tag>
            </span>
            <span slot="status" slot-scope="text">
              <a-tag :color="text === 1 ? 'green' : 'red'">
                {{ text === 1 ? '正常' : '禁用' }}
              </a-tag>
            </span>
            <span slot="isAllowAllocate" slot-scope="text, record">
              <a-radio-group
                v-if="isModuleSelected(record.id)"
                :value="getModuleConfig(record.id).isAllowAllocate"
                size="small"
                @change="(e) => handleConfigChange(record.id, 'isAllowAllocate', e.target.value)"
              >
                <a-radio :value="false">否</a-radio>
                <a-radio :value="true">是</a-radio>
              </a-radio-group>
              <span v-else>-</span>
            </span>
            <span slot="isSubAutoIntegrate" slot-scope="text, record">
              <a-radio-group
                v-if="isModuleSelected(record.id)"
                :value="getModuleConfig(record.id).isSubAutoIntegrate"
                size="small"
                @change="(e) => handleConfigChange(record.id, 'isSubAutoIntegrate', e.target.value)"
              >
                <a-radio :value="false">否</a-radio>
                <a-radio :value="true">是</a-radio>
              </a-radio-group>
              <span v-else>-</span>
            </span>
            <span slot="endTime" slot-scope="text, record">
              <a-date-picker
                v-if="isModuleSelected(record.id)"
                :value="getEndTimeValue(record.id)"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择截止日期"
                style="width: 100%"
                :disabled-date="disabledDate"
                @change="(date) => handleConfigChange(record.id, 'endTime', date)"
              />
              <span v-else>-</span>
            </span>
          </a-table>
        </a-form-model-item>
      </a-form-model>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="onClose">取消</a-button>
        </a-space>
      </div>
    </a-card>
  </a-drawer>
</template>

<script>
import { pageModule, addModuleTenant } from '@/api/system/module'
import { getTenant } from '@/api/system/tenant'
import moment from 'moment'

export default {
  name: 'ModuleTenantForm',
  data() {
    return {
      visible: false,
      submitLoading: false,
      moduleLoading: false,
      tenantId: undefined,
      tenantName: '',
      searchKeyword: '',
      moduleList: [],
      selectedModuleIds: [],
      selectedModulesConfig: [],
      presetSelectedModules: [],
      modulePagination: {
        current: 1,
        pageSize: 100,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      form: {
        selectedModules: [],
      },
      rules: {
        selectedModules: [{ required: true, message: '请至少选择一个功能模块', trigger: 'change' }],
      },
      moduleColumns: [
        {
          title: '模块名称',
          dataIndex: 'moduleName',
          key: 'moduleName',
          align: 'center',
          width: 150,
        },
        {
          title: '模块类型',
          dataIndex: 'moduleSystemType',
          key: 'moduleSystemType',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'moduleSystemType' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '是否允许分配',
          dataIndex: 'isAllowAllocate',
          key: 'isAllowAllocate',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'isAllowAllocate' },
        },
        {
          title: '下级自动集成',
          dataIndex: 'isSubAutoIntegrate',
          key: 'isSubAutoIntegrate',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'isSubAutoIntegrate' },
        },
        {
          title: '截止日期',
          dataIndex: 'endTime',
          key: 'endTime',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'endTime' },
        },
      ],
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedModuleIds,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          disabled: record.status !== 1,
        }),
      }
    },
  },
  methods: {
    init(record) {
      this.tenantId = record.id
      this.tenantName = record.name || ''
      this.visible = true
      // 先设置回显数据，再加载列表，这样列表加载完成后会自动显示选中状态
      const selectedModules = record.selectedModules || []
      if (selectedModules && selectedModules.length > 0) {
        this.selectedModuleIds = selectedModules.map((item) => item.moduleId)
        this.selectedModulesConfig = selectedModules.map((item) => ({
          moduleId: item.moduleId,
          isAllowAllocate: item.isAllowAllocate || false,
          isSubAutoIntegrate: item.isSubAutoIntegrate || false,
          endTime: item.endTime || null,
        }))
        this.form.selectedModules = this.selectedModuleIds
        this.presetSelectedModules = selectedModules
      } else {
        this.selectedModuleIds = []
        this.selectedModulesConfig = []
        this.presetSelectedModules = []
        this.form.selectedModules = []
      }
      this.searchKeyword = ''
      this.modulePagination.current = 1
      this.getTenantName()
      this.getModuleList()
    },
    resetForm() {
      this.form = {
        selectedModules: [],
      }
      this.selectedModuleIds = []
      this.selectedModulesConfig = []
      this.presetSelectedModules = []
      this.searchKeyword = ''
      this.modulePagination.current = 1
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    async getTenantName() {
      if (!this.tenantId) {
        return
      }
      try {
        const res = await getTenant(this.tenantId)
        if (res && res.data) {
          this.tenantName = res.data.name || ''
        }
      } catch (error) {
        console.error('获取租户名称失败:', error)
      }
    },
    async getModuleList() {
      this.moduleLoading = true
      try {
        const params = {
          pageNum: this.modulePagination.current,
          pageSize: this.modulePagination.pageSize,
        }
        if (this.searchKeyword) {
          params.moduleName = this.searchKeyword
        }
        const res = await pageModule(params)
        if (res && res.data) {
          this.moduleList = res.data.records || []
          this.modulePagination.total = res.data.total || 0
          // 列表加载完成后，确保已选中的模块被正确回显
          // 由于 rowSelection 使用 computed，selectedModuleIds 的变化会自动更新表格选中状态
          // 这里只需要确保数据已经设置好即可
        } else {
          this.moduleList = []
          this.modulePagination.total = 0
        }
      } catch (error) {
        console.error('获取功能模块列表失败:', error)
        this.$message.error('获取功能模块列表失败')
        this.moduleList = []
      } finally {
        this.moduleLoading = false
      }
    },
    handleSearch() {
      this.modulePagination.current = 1
      this.getModuleList()
    },
    handleTableChange(pagination) {
      this.modulePagination.current = pagination.current
      this.modulePagination.pageSize = pagination.pageSize
      this.getModuleList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedModuleIds = selectedRowKeys
      this.form.selectedModules = selectedRowKeys
      // 更新已选模块配置
      const existingModuleIds = this.selectedModulesConfig.map((item) => item.moduleId)
      // 添加新选中的模块
      selectedRowKeys.forEach((moduleId) => {
        if (!existingModuleIds.includes(moduleId)) {
          // 检查是否有预设的配置（从父组件传入的回显数据）
          const presetConfig = this.presetSelectedModules?.find((item) => item.moduleId === moduleId)
          this.selectedModulesConfig.push({
            moduleId: moduleId,
            isAllowAllocate: presetConfig?.isAllowAllocate || false,
            isSubAutoIntegrate: presetConfig?.isSubAutoIntegrate || false,
            endTime: presetConfig?.endTime || null,
          })
        }
      })
      // 移除取消选中的模块
      this.selectedModulesConfig = this.selectedModulesConfig.filter((item) => selectedRowKeys.includes(item.moduleId))
    },
    isModuleSelected(moduleId) {
      return this.selectedModuleIds.includes(moduleId)
    },
    getModuleConfig(moduleId) {
      let config = this.selectedModulesConfig.find((item) => item.moduleId === moduleId)
      if (!config) {
        config = {
          moduleId: moduleId,
          isAllowAllocate: false,
          isSubAutoIntegrate: false,
          endTime: null,
        }
        this.selectedModulesConfig.push(config)
      }
      return config
    },
    handleConfigChange(moduleId, field, value) {
      const config = this.getModuleConfig(moduleId)
      if (field === 'endTime') {
        config[field] = value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : null
      } else {
        config[field] = Boolean(value)
      }
    },
    getModuleTypeText(type) {
      const map = {
        0: '平台模块',
        1: '系统内置',
        2: '其它模块',
      }
      return map[type] || '未知'
    },
    getModuleTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'default'
    },
    disabledDate(current) {
      return current && current < moment().startOf('day')
    },
    getEndTimeValue(moduleId) {
      const config = this.getModuleConfig(moduleId)
      return config.endTime ? moment(config.endTime, 'YYYY-MM-DD HH:mm:ss') : null
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.selectedModulesConfig || this.selectedModulesConfig.length === 0) {
            this.$message.warning('请至少选择一个功能模块')
            return
          }
          this.submitLoading = true
          const modules = this.selectedModulesConfig.map((config) => {
            const moduleData = {
              moduleId: config.moduleId,
              isAllowAllocate: Boolean(config.isAllowAllocate),
              isSubAutoIntegrate: Boolean(config.isSubAutoIntegrate),
            }
            if (config.endTime) {
              moduleData.endTime = config.endTime
            }
            return moduleData
          })
          const submitData = {
            tenantId: this.tenantId,
            modules,
          }
          addModuleTenant(submitData)
            .then(() => {
              this.$message.success('操作成功')
              this.onClose()
              this.$emit('ok')
            })
            .catch((error) => {
              console.error('操作失败:', error)
              this.$message.error('操作失败')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    },
    onClose() {
      this.visible = false
      this.resetForm()
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
